import React from "react";
import Layout from "../components/Layout";
import DataTable from "../components/DataTable";

const dt = (v) => (v ? new Date(v).toLocaleString("ko-KR") : "");

export default function Sessions() {
  return (
    <Layout title="세션 Sessions">
      <DataTable
        title="Sessions"
        listPath="/api/admin/sessions"
        summaryPath="/api/admin/summary/sessions"
        defaultSort={{ key: "started_at", order: "desc" }}
        columns={[
          { key: "id", label: "ID", sortable: true },
          { key: "session_uuid", label: "session_uuid", sortable: true },
          { key: "status", label: "상태", sortable: true },
          { key: "started_at", label: "시작", sortable: true, render: dt },
          { key: "ended_at", label: "종료", sortable: true, render: dt },
        ]}
      />
    </Layout>
  );
}
